var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"start-page"},[(_vm.step === 'settingNickname')?_c('setting-nickname'):_vm._e(),(_vm.step === 'info')?_c('info-page'):_vm._e(),(_vm.step === 'bindGoogle')?_c('bind-google-account'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }